import { defineStore } from 'pinia';

export interface Breadcrumb {
  path?: string;
  name?: string;
  type: 'route' | 'modal';
  closeCb?: () => void;
}

interface BreadcrumbState {
  breadcrumbs: Breadcrumb[];
}

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: (): BreadcrumbState => ({
    breadcrumbs: []
  }),
  actions: {
    addBreadcrumb(route: Breadcrumb) {
      this.breadcrumbs.push(route);
    },
    removeLastBreadcrumb() {
      this.breadcrumbs.pop();
    },
    // clearBreadcrumbs() {
    //   this.breadcrumbs = [];
    // },
    back(steps = 1) {
      if (this.breadcrumbs.length === 0) {
        // Check if the current page is an authentication page
        const currentPath = window.location.pathname;
        if (currentPath.startsWith('/auth')) {
          // If we're on auth page, don't go back
          return;
        }
        
        // Check if we have a token (user is logged in)
        const token = localStorage.getItem('token');
        if (token) {
          // User is logged in, check if the previous page was auth
          const referrer = document.referrer;
          if (referrer && (referrer.includes('/auth/') || referrer.includes('/login') || referrer.includes('/register'))) {
            // If we came from auth page, navigate to dashboard instead
            window.location.href = '/dashboard';
            return;
          }
        }
        
        history.go(-1 * steps);
        return;
      }
      for (let i = Math.min(this.breadcrumbs.length, steps); i > 0; i--) {
        const lastBreadcrumb = this.breadcrumbs.pop();
        if (lastBreadcrumb?.type === 'modal' && lastBreadcrumb.closeCb) {
          lastBreadcrumb.closeCb();
        }
      }
    }
  },
  persist: false
});

export default useBreadcrumbStore;
